import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tableChange } from '../../actions/table.actions';
import SimpleSearch from '../../components/core/SimpleSearch';
import ResourceTable from '../../containers/core/ResourceTable';
import { DOSSIER_REQUEST_SCHOOLS_RESOURCE } from '../../resources/dossier.request.schools.resource';
import { tableConfigSelector } from '../../selectors/resources.selectors';
import overviewService from '../../services/api/overview.service';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const AddSchoolToRequestModal = ({ dossierId, isOpen, onUpdated, onClose, dossierOverviewData }) => {
  const dispatch = useDispatch();
  const modalContentRef = useRef(null);
  const [search, setSearch] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const resource = {
    ...DOSSIER_REQUEST_SCHOOLS_RESOURCE,
    table: {
      ...DOSSIER_REQUEST_SCHOOLS_RESOURCE.table,
      highlight: (item) => selected?.id === item.id,
      highlightType: 'success'
    }
  };
  const config = useSelector((state) => tableConfigSelector(state, { resource }));
  const reset = () => {
    setSelected(null);
    clearSearch();
  };

  const handleClose = () => {
    onClose();
    reset();
  };

  const handleConfirm = () => {
    const options = {
      onSuccess: () => {
        setIsSubmitting(false);
        handleClose();
        onUpdated();
      },
      onError: (message) => {
        setIsSubmitting(false);
        setSubmitError(message);
      }
    };
    setIsSubmitting(true);
    const newBranchData = dossierOverviewData?.branch.includes({ id: selected.branchId, name: selected.branch })
      ? [...dossierOverviewData?.branch]
      : [...dossierOverviewData?.branch, { id: selected.branchId, name: selected.branch }];
    overviewService.update(dossierId, { branch: newBranchData }, options);
  };

  const handleSelect = (item) => {
    if (selected && selected.id === item.id) {
      setSelected(null);
    } else {
      setSelected(item);
    }
  };

  const handleSearch = () => {
    dispatch(
      tableChange(resource, {
        ...config,
        search
      })
    );
    if (!hasSearched) {
      setHasSearched(true);
    }
  };

  const onInputSearch = (value) => {
    setSearch(value);
    setSelected(null);
  };

  const clearSearch = () => {
    setSearch('');
  };

  return (
    <>
      <Modal
        ref={modalContentRef}
        title={<ModalTitle title="School toevoegen" />}
        isOpen={isOpen}
        isSubmitting={isSubmitting}
        onClose={handleClose}
        canConfirm={!!selected}
        onConfirm={handleConfirm}
        onConfirmLabel="Toevoegen"
        onConfirmIcon="ai-check-1"
        onConfirmType="success"
        width={1000}
      >
        <SimpleSearch
          className="u-margin-bottom-md"
          query={search}
          onChange={onInputSearch}
          onSearch={handleSearch}
          onClear={clearSearch}
        />
        {hasSearched && <ResourceTable resource={resource} onRowClick={handleSelect} />}
        {submitError && <small className="u-block u-margin-top-sm u-text-danger">{submitError}</small>}
      </Modal>
    </>
  );
};

export default AddSchoolToRequestModal;
